// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
module.exports = {
    hasDateInput: $foreign.hasDateInput
};
